(function () {
    'use strict';

    angular
        .module('bcmModule')
        .controller('biaBuOwnerSummaryController', Controller);

    Controller.$inject = ['$scope'];

    function Controller($scope) {

        $scope.ctrlCtxt = {
            isDetailsContentOpen: $scope.boxModel.IsBusinessUnitOwner
        };

        init();

        // Toggle Details Content
        $scope.toggleDetails = function () {
            $scope.ctrlCtxt.isDetailsContentOpen = !$scope.ctrlCtxt.isDetailsContentOpen;
        };

        // Does the Responsibility has Rating Comments
        $scope.hasImpactRatingComments = function (responsibility) {
            return responsibility.ComplianceImpactDetails
                ||  responsibility.FinancialImpactDetails
                ||  responsibility.OperationalImpactDetails;
        };

        // Toggle Impact Rating Comments
        $scope.toggleImpactRatingComments = function (responsibility) {
            responsibility._areCommentsOpen = !responsibility._areCommentsOpen;
        };

        function init() {
            // Group Responsibilities by Priority
            $scope.respByPriorityId = _.groupBy($scope.boxContext.BIAResponsibilities, 'PriorityLevelID');
        }
    }
})();